import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, of, switchMap } from 'rxjs';
import { HelperService } from 'src/app/service/helper.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { CommunicationEventPurposeType } from '../../children/model/student-communication-events';

@Injectable({
    providedIn: 'root'
})
export class CommunicationEventPurposeTypeDataService extends DefaultDataService<CommunicationEventPurposeType> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, public urlProvider: UrlProviderService, public helperService: HelperService) {
        super('TermType', http, httpUrlGenerator);
    }

    override getAll(): Observable<CommunicationEventPurposeType[]> {
        const url = this.urlProvider.getUrl(EndPoints.studentCommunicationEvents_GetCommunicationEventPurposeTypes, undefined, undefined);
        return this.http
            .get(
                url,
                (Headers = {
                    ...this.urlProvider.baseGetOptions()
                })
            )
            .pipe(
                switchMap((res: any) => {
                    return of(res.body['communicationEventPurposeTypes']);
                })
            );
    }
}
